import {Component, Input, OnInit, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import { TabModel } from 'src/app/models/tabModel';
import { HeaderButton } from 'src/app/shared/components/header/header.types';
import { BackUrl } from '../layout/layout.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter, map, startWith, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input() icon: string;
  @Input() title: string;
  @Input() backUrl: BackUrl | null;
  @Input() backUrlStr: string | null;
  @Input() tabs: TabModel[] | null;
  @Input() buttons: HeaderButton[];
  @Input() headerRef: TemplateRef<unknown>;
  @Input() relativePath = false;

  url$: Observable<string>;

  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.url$ = this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(this.router),
        map((event) => this.relativePath ? event.url.substring(0, event.url.lastIndexOf('/') + 1) : ''),
    );
  }
}
